import React from "react"
import {withRouter} from "react-router-dom"
import PropertyTourEditPhotos from "./property_tour_edit_photos"
import noImagePlaceholderSrc from '../../../../assets/images/no-image.jpeg'
import noImageAvatarPlaceholderSrc from "../../../../assets/images/avatar.png"
import PageHeader from "../page_header"
import {fetchProject, fetchProjectMedias} from "../../util/project_api_util";
import PropertyTourEditExternalPhotos from "./property_tour_edit_external_photos";
import { formatPhoneNumber } from "../../util/easy_format_utils"
import { updateProfile } from "../../util/settings_api_util"


class PropertyTourEditMain extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      project: null,
      modelLink: "",
      videoLink: "",
      description: "",
      property_mls_id: "",
      beds: "",
      baths: "",
      price: "",
      square_feet: "",
      lot_size: "",
      agent_email: "",
      agent_name: "",
      agent_phone_number: "",
      agent_company: "",
      co_agent_email: "",
      co_agent_name: "",
      co_agent_phone_number: "",
      co_agent_company: "",
      co_agent_avatar: "",
      co_agent_avatar_src: "",
      cover: "",
      cover_src: "",
      cover_url: "",
      avatar: "",
      avatar_src: "",
      hidden_medias: {},
      sorted_medias: {},
      changed_medias: {},
      propertyErrors: [],
      loading: false,
      showCoAgent: false,
    }

    this.handler = this.handler.bind(this)
    this.fetchMedias = this.fetchMedias.bind(this)
    this.handleInput = this.handleInput.bind(this)
    this.handleCoverSelected = this.handleCoverSelected.bind(this)
    this.handleAgentAvatarSelected = this.handleAgentAvatarSelected.bind(this)
    this.handleCoAgentAvatarSelected = this.handleCoAgentAvatarSelected.bind(this)
    this.updatePropertyTour = this.updatePropertyTour.bind(this)
    this.handleCoverFromUrl = this.handleCoverFromUrl.bind(this)
    this.handleCoverReset = this.handleCoverReset.bind(this)
  }

  componentDidMount() {
    const projectId = this.props.match.params.id
    fetchProject(projectId).then(response => {
      const project = Object.values(response)[0]
      this.setState({
        project,
        property_mls_id: project.property_mls_id || "",
        videoLink: project.external_video_id || "",
        modelLink: project.external_model_id || "",
        description: project.description || "",
        beds: project.beds || "",
        baths: project.baths || "",
        price: project.price || "",
        square_feet: project.square_feet || "",
        cover_src: project.property_tour_cover || "",
        lot_size: project.lot_size || "",
        avatar_src: project.agent_avatar || "",
        agent_email: project.agent_email || "",
        agent_name: project.agent_name || "",
        agent_phone_number: project.agent_phone_number || "",
        agent_company: project.agent_company || this.props.currentUser?.companyName || "",
        co_agent_avatar_src: project.co_agent_avatar || "",
        co_agent_email: project.co_agent_email || "",
        co_agent_name: project.co_agent_name || "",
        co_agent_phone_number: project.co_agent_phone_number || "",
        co_agent_company: project.co_agent_company || "",
        showCoAgent: !!(project.co_agent_name || project.co_agent_email || project.co_agent_phone_number || project.co_agent_company || project.co_agent_avatar),
      })
    })
    window.scrollTo(0, 0)
  }

  updateProjectExternalPhotos(project) {
    this.state.project.external_photos = project.external_photos
    this.setState({project: {...this.state.project}})
  }

  fetchMedias(service_id) {
    const projectId = this.props.match.params.id
    return fetchProjectMedias(projectId, service_id).then((response) => {
      const projectMedias = Object.values(response)[0]
      this.setState({project: {...this.state.project, ...projectMedias}})
    })
  }

  componentWillUnmount() {
    URL.revokeObjectURL(this.state.cover_src)
  }

  handleCoverSelected(event) {
    let cover = event.target.files[0]
    let cover_src = URL.createObjectURL(cover)

    this.setState({
      cover: cover,
      cover_src: cover_src
    })
  }

  handleAgentAvatarSelected(event){
    let avatar = event.target.files[0]
    let avatar_src = URL.createObjectURL(avatar)

    this.setState({
      avatar: avatar,
      avatar_src: avatar_src
    })
  }

  handleCoAgentAvatarSelected(event){
    let avatar = event.target.files[0]
    let avatar_src = URL.createObjectURL(avatar)

    this.setState({
      co_agent_avatar: avatar,
      co_agent_avatar_src: avatar_src
    })
  }

  handleInput(field) {
    return e => {
      let value = e.currentTarget.value;

      // Strip non-digit characters only for phone number fields
      if (field.includes('phone')) {
        value = value.replace(/\D/g, '');
      }

      this.setState({ [field]: value });
    };
  }

  handler(newState) {
    this.setState(newState)
  }

  updatePropertyTour() {
    let formData = new FormData()
    formData.append("project[external_model_id]", this.state.modelLink)
    formData.append("project[external_video_id]", this.state.videoLink)
    formData.append("id", this.state.project.id)

    const fields = ['description', 'baths', 'beds', 'square_feet', 'price', 'property_mls_id', 'lot_size', 'agent_name', 'agent_phone_number', 'agent_email', 'agent_company', 'co_agent_name', 'co_agent_phone_number', 'co_agent_email', 'co_agent_company']
    for (const field of fields) {
      formData.append(`project[${field}]`, this.state[field])
    }

    // Also save the agent's company back to their own profile, so it pre-fills
    // on future listings instead of needing to be re-entered every time.
    if (this.state.agent_company !== (this.props.currentUser?.companyName || "")) {
      const companyFormData = new FormData()
      if (this.props.currentUser?.companyId) {
        companyFormData.append("user[company_attributes][id]", this.props.currentUser.companyId)
      }
      companyFormData.append("user[company_attributes][company_name]", this.state.agent_company)
      updateProfile(companyFormData, this.props.currentUser.id)
    }

    if (this.state.cover_url) {
      formData.append("project[cover_url]", this.state.cover_url)
    } else if (this.state.cover !== "") {
      formData.append("project[cover]", this.state.cover)
    }

    if (this.state.avatar !== ""){
      formData.append("project[agent_avatar]", this.state.avatar)
      if (!this.props.currentUser.avatar) {
        const avatarFormData = new FormData()
        avatarFormData.append("user[avatar]", this.state.avatar)
        updateProfile(avatarFormData, this.props.currentUser.id)
      }
    }

    if (this.state.co_agent_avatar !== ""){
      formData.append("project[co_agent_avatar]", this.state.co_agent_avatar)
    }

    this.setState({loading: true})

    this.props.updatePropertyTour(formData).then(() => {
      let sorted = Object.values(this.state.sorted_medias)

      let all_sorted_medias = {}

      sorted.forEach((sorted_group) => {
        sorted_group.forEach((media, index) => {
          all_sorted_medias[media.id] = index
        })
      })

      this.props.sortMedia(all_sorted_medias)
    }).then(() => {
      this.props.toggleHiddenMedia(Object.values(this.state.changed_medias))
    }).then(() => {
      this.showSavingLabel()
      this.setState({loading: false})
    }).catch(() => {
      this.setState({loading: false})
    })
  }

  setPublished(published) {
    let formData = new FormData()
    formData.append("id", this.state.project.id)
    formData.append("project[published]", published)
    this.setState({ loading: true })
    this.props.updatePropertyTour(formData).then(() => {
      this.setState({ loading: false, project: { ...this.state.project, published } })
      this.props.showToast(published ? "Listing website published" : "Listing website unpublished - changes will take effect on Google's next crawl")
    }).catch(() => {
      this.setState({ loading: false })
    })
  }

  handleCoverFromUrl(url) {
    this.setState({ cover_src: url, cover_url: url, cover: "" })
  }

  handleCoverReset() {
    this.setState({
      cover_src: this.state.project?.property_tour_cover || "",
      cover: "",
      cover_url: "",
    })
  }

  showSavingLabel() {
    this.props.showToast("Listing website changes have been saved")
  }

  render() {
    const {project} = this.state
    if (!project) return <div/>

    const projectAddress = [
      project.address?.street1, project.address?.city, project.address?.region, project.address?.zip_code
    ].filter(v => !!v).join(', ')

    return (
      <div className="dashboardMainDiv">
        <PageHeader title={project.address.formatted_address ? `${project.address.apartment_number || ""} ${project.address.formatted_address}` : projectAddress} back="Back to Listing Website page" backLink={`/${project.slug}/listing-website`}/>

        <div className="editProjectSection d-block">
          <div className="propertyTourSectionBody">
            <button className="propertyTourEditButton" onClick={this.updatePropertyTour} disabled={this.state.loading}>
              Save
            </button>
          </div>

          <div className="propertyTourSectionBody">
            <h5 className="propertyTourSectionTitle">Property Information</h5>
            <div className="floatingLabelsForm mt-4">
              <div className="row">
                <div className="col-12">
                  <div className="inputGroup">
                    <label className="required">Property Description</label>
                    <textarea className="formInput" placeholder="Content" onChange={this.handleInput("description")}
                              value={this.state.description} style={{minHeight: '85px'}}/>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-12 col-md-6">
                  <div className="inputGroup">
                    <label className="required">Asking Price</label>
                    <input className="formInput" placeholder="$345,678" onChange={this.handleInput("price")}
                           value={this.state.price ? parseInt(this.state.price) : ""} type="number"/>
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="inputGroup">
                    <label>MLS ID</label>
                    <input className="formInput" placeholder="Content" onChange={this.handleInput("property_mls_id")}
                           value={this.state.property_mls_id}/>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-12 col-lg-3 col-md-6">
                  <div className="inputGroup">
                    <label>Number of beds</label>
                    <input className="formInput" placeholder="Content" onChange={this.handleInput("beds")}
                           value={this.state.beds} type="number"/>
                  </div>
                </div>
                <div className="col-12 col-lg-3 col-md-6">
                  <div className="inputGroup">
                    <label>Number of baths</label>
                    <input className="formInput" placeholder="Content" onChange={this.handleInput("baths")}
                           value={this.state.baths} type="number"/>
                  </div>
                </div>

                <div className="col-12 col-lg-3 col-md-6">
                  <div className="inputGroup">
                    <label>Square feet</label>
                    <input className="formInput" placeholder="Content" onChange={this.handleInput("square_feet")}
                           value={this.state.square_feet} type="number"/>
                  </div>
                </div>
                <div className="col-12 col-lg-3 col-md-6">
                  <div className="inputGroup">
                    <label>Lot Size (in acres)</label>
                    <input className="formInput" placeholder="Content" step="0.01" onChange={this.handleInput("lot_size")}
                           value={this.state.lot_size} type="number"/>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="propertyTourSectionBody">
            <h5 className="propertyTourSectionTitle">Edit Agent Information</h5>
            <div className="propertyTourEditMediaSection propertyTourEditMediaAvatarSection propertyTourEditMediaSectionMain">
              <img className="agentAvatar" src={this.state.avatar_src || noImageAvatarPlaceholderSrc} />
              <div className="propertyTourEditMediaSectionAvatarInput">
                <label htmlFor="avatarImg" className="propertyTourEditButton">
                  Upload photo
                  <input type="file" className="d-none" id="avatarImg" accept="image/*"
                    onChange={this.handleAgentAvatarSelected} />
                </label>
              </div>
            </div>
            <div className="floatingLabelsForm mt-2">
              <div className="row">
                <div className="col-12 col-lg-3 col-md-6">
                  <div className="inputGroup">
                    <label>Agent Name</label>
                    <input className="formInput" placeholder="Full Name" onChange={this.handleInput("agent_name")}
                      value={this.state.agent_name} type="text" />
                  </div>
                </div>
                <div className="col-12 col-lg-3 col-md-6">
                  <div className="inputGroup">
                    <label>Agent Email</label>
                    <input className="formInput" placeholder="Email" onChange={this.handleInput("agent_email")}
                      value={this.state.agent_email} type="email" />
                  </div>
                </div>
                <div className="col-12 col-lg-3 col-md-6">
                  <div className="inputGroup">
                    <label>Agent Phone Number</label>
                    <input className="formInput" placeholder="Phone Number" onChange={this.handleInput("agent_phone_number")}
                      value={formatPhoneNumber(this.state.agent_phone_number)} type="phone_number" />
                  </div>
                </div>
                <div className="col-12 col-lg-3 col-md-6">
                  <div className="inputGroup">
                    <label>Agent Company</label>
                    <input className="formInput" placeholder="Brokerage" onChange={this.handleInput("agent_company")}
                      value={this.state.agent_company} type="text" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="propertyTourSectionBody">
            {this.state.showCoAgent ? (
              <>
                <div className="d-flex align-items-center justify-content-between w-100">
                  <h5 className="propertyTourSectionTitle">Co-Agent Information (optional)</h5>
                  <button className="propertyTourEditButton propertyTourEditButtonInactive" onClick={() => this.setState({ showCoAgent: false })}>
                    Hide Co-Agent
                  </button>
                </div>
                <div className="propertyTourEditMediaSection propertyTourEditMediaAvatarSection propertyTourEditMediaSectionMain">
                  <img className="agentAvatar" src={this.state.co_agent_avatar_src || noImageAvatarPlaceholderSrc} />
                  <div className="propertyTourEditMediaSectionAvatarInput">
                    <label htmlFor="coAgentAvatarImg" className="propertyTourEditButton">
                      Upload photo
                      <input type="file" className="d-none" id="coAgentAvatarImg" accept="image/*"
                        onChange={this.handleCoAgentAvatarSelected} />
                    </label>
                  </div>
                </div>
                <div className="floatingLabelsForm mt-2">
                  <div className="row">
                    <div className="col-12 col-lg-3 col-md-6">
                      <div className="inputGroup">
                        <label>Co-Agent Name</label>
                        <input className="formInput" placeholder="Full Name" onChange={this.handleInput("co_agent_name")}
                          value={this.state.co_agent_name} type="text" />
                      </div>
                    </div>
                    <div className="col-12 col-lg-3 col-md-6">
                      <div className="inputGroup">
                        <label>Co-Agent Email</label>
                        <input className="formInput" placeholder="Email" onChange={this.handleInput("co_agent_email")}
                          value={this.state.co_agent_email} type="email" />
                      </div>
                    </div>
                    <div className="col-12 col-lg-3 col-md-6">
                      <div className="inputGroup">
                        <label>Co-Agent Phone Number</label>
                        <input className="formInput" placeholder="Phone Number" onChange={this.handleInput("co_agent_phone_number")}
                          value={formatPhoneNumber(this.state.co_agent_phone_number)} type="phone_number" />
                      </div>
                    </div>
                    <div className="col-12 col-lg-3 col-md-6">
                      <div className="inputGroup">
                        <label>Co-Agent Company</label>
                        <input className="formInput" placeholder="Brokerage" onChange={this.handleInput("co_agent_company")}
                          value={this.state.co_agent_company} type="text" />
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <button className="propertyTourEditButton propertyTourEditButtonInactive" onClick={() => this.setState({ showCoAgent: true })}>
                + Add Co-Agent
              </button>
            )}
          </div>

          <div className="propertyTourSectionBody">
            <h5 className="propertyTourSectionTitle">Media & Gallery</h5>
            <PropertyTourEditPhotos changed_medias={this.state.changed_medias}
                                    sorted_medias={this.state.sorted_medias} hidden_medias={this.state.hidden_medias}
                                    isLargeScreen={this.props.isLargeScreen} project={project}
                                    fetchMedias={this.fetchMedias} changeParentState={this.handler}
                                    onCoverSelected={this.handleCoverFromUrl}
                                    onCoverReset={this.handleCoverReset}
                                    currentCoverSrc={this.state.cover_src}/>
          </div>

          {this.props.currentUser?.roles?.admin && (
            <div className="propertyTourSectionBody">
              <h5 className="propertyTourSectionTitle">Custom photos upload</h5>
              <PropertyTourEditExternalPhotos isLargeScreen={this.props.isLargeScreen}
                                              project={project}
                                              showToast={msg => this.props.showToast(msg)}
                                              onReload={project => this.updateProjectExternalPhotos(project)}/>
            </div>
          )}

          {project.services.some(s => s.media_types === "matterport") && (
            <div className="propertyTourSectionBody">
              <h5 className="propertyTourSectionTitle">3D model iframe</h5>
              <div className="propertyTourEditMediaSection propertyTourEditMediaSectionMain">
                {this.state.modelLink ?
                  <iframe className="propertyTourEditCoverImage" src={this.state.modelLink}/> :
                  <img src={noImagePlaceholderSrc} className="propertyTourEditCoverImage"/>}

                <div className="propertyTourEditMediaSectionInput floatingLabelsForm">
                  <div className="inputGroup w-100">
                    <label>Model Link</label>
                    <input className="formInput w-100" placeholder="Content"
                           onChange={this.handleInput("modelLink")}
                           value={this.state.modelLink}/>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="propertyTourSectionBody">
            <h5 className="propertyTourSectionTitle">Video iframe</h5>
            <div className="propertyTourEditMediaSection propertyTourEditMediaSectionMain">
              {this.state.videoLink ? (
                  <video className="propertyTourEditCoverImage" controls>
                    <source src={this.state.videoLink} type="video/mp4"/>
                  </video>) :
                <img src={noImagePlaceholderSrc} className="propertyTourEditCoverImage"/>
              }
              <div className="propertyTourEditMediaSectionInput floatingLabelsForm">
                <div className="inputGroup w-100">
                  <label>Video Link</label>
                  <input className="formInput w-100" placeholder="https://youtube.com/123456789"
                         onChange={this.handleInput("videoLink")}
                         value={this.state.videoLink}/>
                </div>
              </div>
            </div>
          </div>

          <div className="propertyTourSectionFooter">
            <div className="d-flex align-items-center justify-content-between w-100">
              <button className="propertyTourEditButton" onClick={this.updatePropertyTour} disabled={this.state.loading}>
                Save
              </button>
              {this.state.project?.published
                ? <button className="propertyTourEditButton" onClick={() => this.setPublished(false)} disabled={this.state.loading}>Unpublish from Google Search</button>
                : <button className="propertyTourEditButton" onClick={() => this.setPublished(true)} disabled={this.state.loading}>Publish to Google Search</button>
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(PropertyTourEditMain)